module.exports = __webpack_public_path__ + "SuryaVamsi3-42d66f95.png";